import { render, staticRenderFns } from "./SearchFacetWrapper.vue?vue&type=template&id=3b53d1d6"
import script from "./SearchFacetWrapper.vue?vue&type=script&lang=ts"
export * from "./SearchFacetWrapper.vue?vue&type=script&lang=ts"
import style0 from "./SearchFacetWrapper.vue?vue&type=style&index=0&id=3b53d1d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports